import React from 'react';

import ErrorCard from '../../../../../components/ErrorCard/ErrorCard';

const PrimaryRouteNotImplemented = () => {
  return <ErrorCard />;
};

export default PrimaryRouteNotImplemented;
